import { render, staticRenderFns } from "./decorationlist.vue?vue&type=template&id=4dc79d3a&"
import script from "./decorationlist.vue?vue&type=script&lang=js&"
export * from "./decorationlist.vue?vue&type=script&lang=js&"
import style0 from "./decorationlist.vue?vue&type=style&index=0&id=4dc79d3a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc79d3a')) {
      api.createRecord('4dc79d3a', component.options)
    } else {
      api.reload('4dc79d3a', component.options)
    }
    module.hot.accept("./decorationlist.vue?vue&type=template&id=4dc79d3a&", function () {
      api.rerender('4dc79d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/decorationlist.vue"
export default component.exports